import React from 'react';

import { compose } from 'redux';
import classnames from 'classnames';

import { RESOURCE_DETAIL_URL } from 'global-constants';
import image from 'assets/images/homepage/proptech_explanation_image.png';

import { substituteUrl } from 'shared/utils/substituteUrl';

import WithPush from 'shared/HOCs/WithPush';
import WithVendorCount from 'shared/HOCs/WithVendorCount';

import Image from 'shared/components/Image';
import Button from 'shared/components/Button';

import styles from './styles.module.scss';

const PropTechExplanationBox = ({ push, vendorCount }) => (
  <div className={classnames(styles.container, 'container')}>
    <div className={styles.left}>
      <div className={styles.title}>What is PropTech, and how can it help?</div>
      <div className={styles.description}>
        We've classified and categorised over {vendorCount} PropTech, ReTech and
        Cretech companies from around the globe. Discover our definition and the
        important role it plays in the digital transformation of real estate.
      </div>
      <Button
        color="primary"
        className={styles.button}
        onClick={() =>
          push(
            substituteUrl(RESOURCE_DETAIL_URL, {
              resourceSlug: 'what-is-proptech'
            })
          )
        }>
        Find out
      </Button>
    </div>
    <div className={styles.right}>
      <div className="remove-xs">
        <Image src={image} width="563" height="466" />
      </div>
      <div className="remove-sm-min">
        <Image src={image} width="100%" />
      </div>
    </div>
  </div>
);

export default compose(
  WithPush,
  WithVendorCount
)(PropTechExplanationBox);
